import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  AppBar,
  Toolbar,
  IconButton,
  FormHelperText,
  Checkbox,
  Divider,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ScrollContainer from "react-indiana-drag-scroll";
import _ from "lodash";
import {
  productsCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import Gap from "../../../components/atoms/Gap";
import useStyles from "./style/stylePilih";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
// import InfiniteScroll from "react-infinite-scroll-component";
// import Divider from "../../../components/Divider";
import { Autocomplete } from "@material-ui/lab";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
// const LIMIT = 6;
// let productsLength = 0;

export default function PilihPromo() {
  const classes = useStyles();
  const history = useHistory();
  const [statusDiskon, setStatusDiskon] = React.useState("semua");
  // const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  // const location = useLocation();
  const { level, webstoreRef, webstore, promo, global_komisi } = useData();
  const [pilih, setPilih] = React.useState(false);
  // const [simpan, setSimpan] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  // const [loadingMore, setLoadingMore] = React.useState(true);
  const [products, setProducts] = React.useState([]);
  const [productsFilter, setProductsFilter] = React.useState([]);
  const [ids, setIds] = React.useState([]);
  const [diskon, setDiskon] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const angka = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
  const [nilai, setNilai] = React.useState(0);
  const webstoreProductDiscont = webstore?.products_discount
  // const matches = useMediaQuery(theme.breakpoints.up("890"));
  // const matches1 = useMediaQuery(theme.breakpoints.up("705"));

  // useEffect(() => {
  //   let allProductsLength = Math.max(products.length, ids.length);

  //   if (productsLength < allProductsLength) {
  //     productsLength = allProductsLength;
  //   }
  // }, [products, ids]);

  useEffect(() => {
    async function getProducts() {
      setLoading(true);
      setProducts([]);
      // limit 2 products in

      try {
        let arr = [];
        await Promise.all(
          [...webstore?.products]?.reverse()?.map(async (item) => {
            const pro = await productsCollection.doc(item).get();
            // console.log("b", await pro.ref.collection("variants").get());
            if (!pro.empty) {
              const variants = await pro.ref.collection("variants").get();
              const prodVariant = {
                id: pro?.id,
                id_produk: pro?.id,
                ...pro?.data(),
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
              arr.push(prodVariant);
            }
            // console.log("prod", arr);
            setProducts([...arr]);
          })
        );
        setDiskon(webstoreProductDiscont ?? {});
        // setNilai(
        //   webstore?.products_discount[
        //     Object.keys(webstore?.products_discount)[0]
        //   ].nilai
        // );
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    }
    getProducts();
  }, []);

  useEffect(() => {
    if (statusDiskon === "semua") {
      setProductsFilter([...products]);
    } else if (statusDiskon === "normal") {
      setProductsFilter(
        products?.filter(
          (item) => !Object?.keys(webstoreProductDiscont??{}).includes(item?.id)
        )
      );
    } else if (statusDiskon === "diskon") {
      setProductsFilter(
        products?.filter((item) =>
          Object?.keys(webstoreProductDiscont??{}).includes(item?.id)
        )
      );
    }
    // console.log("lol");
    setIds([]);
    setNilai(0);
    // setSimpan(false);
  }, [products, statusDiskon, webstoreProductDiscont]);

  // console.log(ids);
  const handlePilih = (id) => (e) => {
    const selectedIndex = ids.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(ids, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(ids.slice(1));
    } else if (selectedIndex === ids.length - 1) {
      newSelected = newSelected.concat(ids.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        ids.slice(0, selectedIndex),
        ids.slice(selectedIndex + 1)
      );
    }
    setIds(newSelected);
  };

  // console.log(diskon);

  const handlePilihAll = () => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    let arr = [];
    productsFilter?.map((item) => arr.push(item?.id));
    setIds([...new Set(arr)]);
    setSubmitting(false);
  };

  const handleBatalAll = () => {
    // setSimpan(false);
    setIds([]);
    setNilai(0);
  };
  // console.log(diskon);
  const handleSave = async () => {
    if (submitting) {
      return;
    }
    setSubmitting(true);
    try {
      await webstoreRef.update({
        products_discount: diskon,
      });

      // history.push("/tokosaya");
      enqueueSnackbar("Produk terpilih berhasil didiskon", {
        variant: "success",
      });
      // setSimpan(false);
      setSubmitting(false);
    } catch (e) {
      console.log(e.message);
      setSubmitting(false);
    }
  };

  const handleSaveAll = async () => {
    // if (submitting) {
    //   return;
    // }
    if (submitting) {
      return;
    }

    setSubmitting(true);
    try {
      let obj = {};
      ids?.map(
        (item) =>
          (obj[item] = {
            error: false,
            id: "promo_toko",
            nilai: Number(nilai),
            tipe: "%",
            // active: "true",
          })
      );

      await webstoreRef.set(
        {
          products_discount: obj,
        },
        { merge: true }
      );

      setDiskon((diskon) => ({
        ...diskon,
        ...obj,
      }));
      // setDiskon(obj)
      // history.push("/tokosaya");
      setPilih(false);
      // setSimpan(false);
      setIds([]);
      setNilai(0);
      setStatusDiskon("diskon");
      setSubmitting(false);
      enqueueSnackbar("Produk terpilih berhasil didiskon", {
        variant: "success",
      });
    } catch (e) {
      console.log(e.message);
      setSubmitting(false);
    }
  };

  const handleHapus = async (item) => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    // let obj = { ...diskon };
    delete webstoreProductDiscont?.[item?.id];
    await webstoreRef.update({
      products_discount: webstoreProductDiscont??{},
    });
    // setDiskon((diskon) => ({
    //   ...diskon,
    //   [item?.id]: {
    //     ...diskon[item?.id],
    //     nilai: 0,
    //   },
    // }));
    setDiskon((diskon) => {
      // let obj = { ...diskon };
      delete diskon[item?.id];
      return diskon;
    });
    setSubmitting(false);
  };

  const handleHapusAll = async () => {
    if (submitting) {
      return;
    }
    try {
      setSubmitting(true);
      // const webstoreProductDiscont = webstore?.products_discount;
      ids.forEach((a) => {
        delete webstoreProductDiscont?.[a];
        // return webstoreProductDiscont
      });
      // console.log(
      //   ids,
      //   // webstore?.products_discount,
      //   webstoreProductDiscont
      // );
      // delete webstore?.products_discount?.[item?.id];
      // await webstoreRef.update({
      //   products_discount: webstore?.products_discount,
      // });

      await webstoreRef.update({
        products_discount: webstoreProductDiscont??{},
      });

      ids?.forEach((a) => {
        setDiskon((diskon) => {
          // let obj = { ...diskon };
          delete diskon[a];
          return diskon;
        });
        return a;
      });
      // history.push("/tokosaya");
      enqueueSnackbar("diskon produk terpilih berhasil dihapus", {
        variant: "success",
      });
      setPilih(false);
      // setSimpan(false);
      setIds([]);
      setNilai(0);
      setSubmitting(false);
    } catch (e) {
      console.log(e.message);
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* <Header
        title="Tambah Promo Produk"
        back
        onClick={() => history.goBack()}
      /> */}
      <AppBar
        style={{
          position: "fixed",
          backgroundColor: "white",
          color: "black",
          maxWidth: "960px",
          left: "auto",
          right: "auto",
        }}
        className={classes.appBar}
      >
        <Toolbar>
          <div
            style={{
              display: "flex",
              // justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => history.push("/tokosaya")}
                aria-label="close"
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="p" className={classes.titleDialog}>
                Setting Diskon Produk Toko
              </Typography>
            </div>
            {/* <div style={{ alignSelf: "center" }}>
              {" "}
              <Button
                variant={ids.length <= 0 ? "contained" : "outlined"}
                color="primary"
                size="small"
                onClick={ids.length <= 0 ? handlePilihAll : handleBatalAll}
                style={{ fontSize: 10 }}
                disabled={submitting || loading}
              >
                {submitting === true ? (
                  <CircularProgress size={20} />
                ) : (
                  <>{ids.length <= 0 ? "Pilih Semua" : "Batal Pilih"}</>
                )}
              </Button>
            </div> */}
          </div>
        </Toolbar>
      </AppBar>
      <Gap height={60} />

      {loading ? (
        <>
          <Gap height={20} />
          <div
            style={{
              display: "flex",
              width: "100%",
              // height: "100vh",
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              // backgroundColor: 'black',
              opacity: 0.4,
              // position: "fixed",
              zIndex: 9999,
              // left: 0,
              // marginBottom: "2.5%",
              marginTop: "25%",
              // right: 0,
              // bottom: 0,
              // top: 0,
            }}
          >
            <CircularProgress />
          </div>
          {/* <SkeletonProduct /> */}
        </>
      ) : !loading && products.length !== 0 ? (
        <>
          <div
            style={{
              marginTop: "20px",
              marginLeft: 24,
              border: "1px solid #5675D3",
              marginRight: 24,
              borderRadius: 4,
              backgroundColor: "#DEE4F7",
              padding: "12px",
              // justifyContent: "center",
              display: "flex",
            }}
          >
            <div>
              <div style={{ marginTop: "2.5px" }}>
                <Typography
                  // color="primary"
                  style={{
                    fontSize: 13.5,
                    // color: "#5675D3",
                    fontWeight: "bold",
                  }}
                >
                  Informasi Diskon
                </Typography>
              </div>
              <div style={{ marginTop: "2.5px" }}>
                <Typography
                  // color="primary"
                  style={{
                    fontSize: 13,
                    // color: "#5675D3",
                  }}
                >
                  Maksimal pemberian diskon untuk produk toko hanya 10%
                </Typography>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // marginBottom: "20px",
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingTop: "20px",
            }}
          >
            <ScrollContainer
              style={{
                display: "flex",
                overflowX: "auto",
                flexWrap: "nowrap",
                // marginLeft: "10px",
                // padding:"20%"
              }}
            >
              {" "}
              <div style={{ marginRight: "10px" }}>
                <Button
                  fullWidth
                  variant="outlined"
                  color={statusDiskon === "semua" ? "primary" : ""}
                  size="small"
                  onClick={() => {
                    setStatusDiskon("semua");
                    setDiskon(webstoreProductDiscont ?? {});
                  }}
                >
                  <Typography
                    noWrap
                    style={{ textTransform: "capitalize", fontSize: 12 }}
                    variant="button"
                  >
                    semua
                  </Typography>
                </Button>
              </div>
              <div style={{ marginRight: "10px" }}>
                <Button
                  fullWidth
                  variant="outlined"
                  color={statusDiskon === "normal" ? "primary" : ""}
                  size="small"
                  onClick={() => {
                    setStatusDiskon("normal");
                    setDiskon(webstoreProductDiscont ?? {});
                  }}
                >
                  <Typography
                    noWrap
                    style={{ textTransform: "capitalize", fontSize: 12 }}
                    variant="button"
                  >
                    normal
                  </Typography>{" "}
                </Button>
              </div>
              <div style={{ marginRight: "10px" }}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  color={statusDiskon === "diskon" ? "primary" : ""}
                  onClick={() => {
                    setStatusDiskon("diskon");
                    setDiskon(webstoreProductDiscont ?? {});
                  }}
                >
                  <Typography
                    noWrap
                    style={{ textTransform: "capitalize", fontSize: 12 }}
                    variant="button"
                  >
                    diskon
                  </Typography>
                </Button>
              </div>
            </ScrollContainer>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingTop: "10px",
              paddingBottom: "5px",
              // width: "100%",
            }}
          >
            <div style={{ alignSelf: "center" }}>
              {pilih ? (
                <Checkbox
                  checked={ids?.length > 0}
                  color="primary"
                  disabled={submitting}
                  indeterminate={ids?.length > 0}
                  onClick={ids?.length > 0 ? handleBatalAll : handlePilihAll}
                />
              ) : null}
              <Typography variant="p" style={{ fontSize: "13px" }}>
                {productsFilter?.length > 0 ? productsFilter?.length : 0} Produk
              </Typography>
            </div>
            <div style={{ alignSelf: "center" }}>
              {" "}
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => {
                  setPilih(!pilih);
                  // setSimpan(false);
                  setIds([]);
                  setNilai(0);
                }}
                style={{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
                disabled={submitting || loading}
              >
                {pilih ? "Batalkan" : "Pilih Sekaligus"}
              </Button>
            </div>
          </div>
          {pilih && ids?.length > 0 ? (
            <Autocomplete
              style={{
                width: "100%",
                paddingLeft: "20px",
                paddingRight: "20px",
                paddingBottom: "15px",
                paddingTop: "5px",
              }}
              id="nilai"
              name="nilai"
              required
              disableClearable
              value={nilai?.toString()}
              onChange={(event, value) => {
                // console.log(value);
                setNilai(Number(value));
                // setSimpan(true);
              }}
              // disabled={isSubmitting}
              options={angka}
              // getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  // margin="dense"
                  {...params}
                  label="Nilai Diskon"
                  InputLabelProps={{ shrink: true }}
                  variant="standard"
                />
              )}
            />
          ) : null}
          <Divider style={{ marginTop: "24px", marginBottom: "24px" }} />
          <Grid container className={classes.root}>
            {productsFilter?.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  width: "100%",
                  padding: "20px",
                  textAlign: "center",
                  marginTop: "20%",
                }}
              >
                <p>
                  <b>Produk Kosong</b>
                </p>
              </div>
            ) : (
              <>
                {productsFilter.map((item, index) => {
                  const stok = item.variants.map(
                    (variant) => variant.stok_available
                  );

                  const productValue =
                    item?.product_value !== undefined &&
                    item?.product_value !== "" &&
                    !Number.isNaN(item?.product_value) &&
                    item?.product_value >= 0
                      ? item?.product_value
                      : 1;

                  const harga = item.variants.map((variant) =>
                    calculateHargaLevel(
                      variant?.harga_normal,
                      global_komisi,
                      level?.level,
                      productValue
                    )
                  );

                  const harga_normal = item.variants.map(
                    (variant) => variant?.harga_normal
                  );

                  const promoFound = findOnePromo(item, promo);

                  const total_stok = stok.reduce((val, nilaiSekarang) => {
                    return val + nilaiSekarang;
                  }, 0);

                  const emptyStock = total_stok === 0 ? true : false;

                  const harga_str = arrayToCurrencyString(harga);
                  const promoF = promoFound ? true : false;

                  const harga_str_promo =
                    promoFound &&
                    arrayToCurrencyStringPromo(
                      harga_normal,
                      promoFound,
                      level.level,
                      global_komisi,
                      productValue
                    );

                  const itemDiskonToko = diskon?.[item?.id];

                  return (
                    <>
                      <div
                        style={{
                          width: "100%",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            // justifyContent: "space-between",
                            width: "100%",
                            borderRadius: 8,
                            // marginBottom: "5px",
                            padding: "10px",
                            backgroundColor: "white",
                          }}
                        >
                          {pilih ? (
                            <Checkbox
                              onClick={handlePilih(item?.id)}
                              color="primary"
                              disabled={submitting}
                              style={{
                                marginRight: "5px",
                                marginLeft: "-15px",
                              }}
                              checked={ids.includes(item.id)}
                            />
                          ) : null}

                          <div
                            style={{
                              display: "flex",
                              // marginLeft: "1.5%",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  width: 60,
                                  height: 60,
                                  marginRight: "10px",
                                }}
                                src={item?.thumbnail?.[0]}
                                alt="logo"
                              />
                            </div>
                            <div style={{ marginLeft: "1.5%" }}>
                              <div style={{ display: "flex" }}>
                                <div style={{ display: "inline-grid" }}>
                                  <Typography
                                    noWrap={true}
                                    style={{
                                      fontSize: 13,
                                      fontWeight: "bold",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {item?.nama}
                                  </Typography>
                                </div>
                              </div>
                              <div>
                                <Typography style={{ fontSize: 13 }}>
                                  {harga_str}
                                </Typography>
                              </div>
                              <div style={{ display: "inline-grid" }}>
                                <Typography noWrap style={{ fontSize: 12 }}>
                                  stok: {total_stok}
                                </Typography>
                              </div>
                            </div>
                          </div>
                        </div>
                        {pilih ? null : (
                          <div
                            style={{ display: "flex", marginBottom: "10px" }}
                          >
                            <Autocomplete
                              key={item?.id}
                              style={{ width: "100%" }}
                              id="nilai"
                              name="nilai"
                              required
                              disableClearable
                              value={diskon?.[item?.id]?.nilai.toString() ?? ""}
                              onChange={(event, value) => {
                                // setSimpan(true);
                                // console.log(value)
                                value > 0
                                  ? setDiskon((diskon) => ({
                                      ...diskon,
                                      [item?.id]: {
                                        id: "promo_toko",
                                        nilai: Number(value),
                                        tipe: "%",
                                        // active: true,
                                        error: false,
                                      },
                                    }))
                                  : setDiskon((diskon) => {
                                      let obj = { ...diskon };
                                      delete obj[item?.id];
                                      return obj;
                                    });
                              }}
                              // disabled={isSubmitting}
                              options={angka}
                              // getOptionLabel={(option) => option.name}
                              renderInput={(params) => (
                                <TextField
                                  // margin="dense"
                                  {...params}
                                  label="Nilai Diskon"
                                  InputLabelProps={{ shrink: true }}
                                  variant="standard"
                                />
                              )}
                            />{" "}
                            {webstoreProductDiscont?.[item?.id] ? (
                              <div
                                style={{
                                  display: "grid",
                                  justifyItems: "center",
                                  width: "100px",
                                  marginRight: "-25px",
                                  marginTop: "-15px",
                                }}
                                onClick={() => handleHapus(item)}
                              >
                                <DeleteOutlineOutlinedIcon color="primary" />
                                <FormHelperText>Hapus</FormHelperText>
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                      <Divider />
                    </>
                  );
                })}
              </>
            )}
          </Grid>
        </>
      ) : !loading && products.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: "100%",
            padding: "20px",
            textAlign: "center",
            marginTop: "25%",
          }}
        >
          <p>
            <b>Toko Anda Masih Kosong</b>
          </p>
        </div>
      ) : null}
      <Gap height={60} />
      {(pilih && ids?.length > 0) ||
      (!_.isEqual(diskon, webstoreProductDiscont) &&
        !pilih &&
        Object.keys(diskon)?.length > 0) ||
      submitting ? (
        <div
          style={{
            position: "fixed",
            backgroundColor: "white",
            bottom: 0,
            maxWidth: "100%",
            width: "960px",
            left: "auto",
            right: "auto",
          }}
        >
          <div
            style={{
              // backgroundColor: "#CBD0F9",
              // padding: "20px",
              paddingRight: "20px",
              paddingLeft: "20px",
              paddingTop: "15px",
              paddingBottom: "10px",
              // height: 50,
              // display: "flex",
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Button
                  style={{ textTransform: "capitalize" }}
                  onClick={pilih ? handleSaveAll : handleSave}
                  fullWidth
                  disabled={
                    loading ||
                    submitting ||
                    (pilih && ids?.length <= 0) ||
                    (nilai <= 0 && pilih)
                  }
                  color="primary"
                  size="small"
                  variant="contained"
                >
                  {submitting ? (
                    <>
                      <CircularProgress size={20} />
                    </>
                  ) : (
                    <>Simpan</>
                  )}
                </Button>
              </Grid>
            </Grid>
            {statusDiskon === "diskon" && pilih && ids?.length > 0 ? (
              <Button
                variant={"contained"}
                color="secondary"
                // size="medium"
                onClick={handleHapusAll}
                style={{ fontSize: 10, width: "100%", marginTop: "10px" }}
                disabled={submitting || loading}
              >
                {submitting ? (
                  <>
                    <CircularProgress size={20} />{" "}
                  </>
                ) : (
                  <>Hapus Diskon</>
                )}
              </Button>
            ) : null}
          </div>
        </div>
      ) : null}
      {/* </InfiniteScroll> */}
      {/* {diskon.length > 0 ? (
        <>
          <div className={classes.boxButton}>
            <div className={classes.buttonSelect} onClick={() => handleBatal()}>
              <h2
                style={{
                  fontFamily: "revert",
                  color: "#C9C5C5",
                  fontSize: matches1 ? 16 : 15,
                }}
              >
                Batalkan
              </h2>
            </div>
            <div
              className={classes.buttonSelect1}
              onClick={() => handleSave()}
              disabled={submitting}
            >
              <h2
                style={{
                  fontFamily: "revert",
                  color: "white",
                  fontSize: matches1 ? 16 : 15,
                }}
              >
                {submitting === true ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Masukkan Produk "
                )}
              </h2>
            </div>
          </div>
        </>
      ) : null} */}
    </>
  );
}
